import React, { Component } from 'react';
import { connect } from 'react-redux'
import CabecalhoTabela from './CabecalhoTabelaRepasseVenda';
import { ItemRepasseVenda } from './ItemRepasseVenda';

export class AbaNaoEmbarcado extends Component {

  render() {
    return (
      <>
        <h4>Tipo Repasse: {this.props.tipoRepasseVenda}</h4>
        {CabecalhoTabela(this.props.tipoRepasseVenda, this.props.abaRepasseVendaSelecionada)}
        <div className="lista-table">
          <div className="geral">
            {this.props.repasseVenda.map((it, index) => <div className={''} key={index}>
              <div className='row resumo'>                
                <ItemRepasseVenda item={it} tipo={this.props.tipoRepasseVenda} />
              </div>
            </div>)}
            {this.props.repasseVenda.length === 0 &&
              <div className="alert alert-warning text-center" role="alert">
                Não foi encontrado resultado para sua pesquisa.
              </div>}
          </div>
        </div>
      </>
    )
  }
}

export const mapStateToProps = state => (
  {
    repasseVenda: state.repasseVenda,
  });

export default connect(mapStateToProps,
  {}
)(AbaNaoEmbarcado)